/* unplugin-vue-components disabled */import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import { useCreditStore } from '@/stores/modules/credit';
import { useUserStore } from '@/stores/modules/user';
import objToArray from '@/shared/objToArray';
import TrackingData from '@/shared/reportDataTracking';
import SelectPopup from '@/components/select-popup.vue';
import { useCreditCommon, useRetainPopup } from '@/composables/useCreditCommon.js';
// use composables
export default {
    __name: 'contacts',
    setup: function(__props) {
        var _useCreditCommon = useCreditCommon(), agreed = _useCreditCommon.agreed, enterTime = _useCreditCommon.enterTime, PrivacyDataBox = _useCreditCommon.PrivacyDataBox;
        var _useRetainPopup = useRetainPopup(), isShowFirstRetainPopup = _useRetainPopup.isShowFirstRetainPopup, isShowSecondRetainPopup = _useRetainPopup.isShowSecondRetainPopup, showSecondRetainPopup = _useRetainPopup.showSecondRetainPopup, goAppHome = _useRetainPopup.goAppHome, CreditFirstRetainPopup = _useRetainPopup.CreditFirstRetainPopup, CreditSecondRetainPopup = _useRetainPopup.CreditSecondRetainPopup;
        var router = useRouter();
        var creditStore = useCreditStore();
        var userStore = useUserStore();
        var onSubmit = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(value) {
                var params, routeObj;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                                taskHandler: 'contact_info_screen-submit',
                                taskState: 1,
                                eventIntervalSpan: new Date() - enterTime.value
                            }));
                            console.log('submit contacts', value);
                            params = {
                                kindSort: 3,
                                contactList: [
                                    {
                                        titleCase: name1.value,
                                        mobileNumber: phone1.value,
                                        linkConnection: codeRelation1.value
                                    },
                                    {
                                        titleCase: name2.value,
                                        mobileNumber: phone2.value,
                                        linkConnection: codeRelation2.value
                                    },
                                    {
                                        titleCase: name3.value,
                                        mobileNumber: phone3.value,
                                        linkConnection: codeRelation3.value
                                    }
                                ]
                            };
                            return [
                                4,
                                creditStore.reqCreditSubmit(params)
                            ];
                        case 1:
                            routeObj = _state.sent();
                            router.push(routeObj);
                            return [
                                2
                            ];
                    }
                });
            });
            return function onSubmit(value) {
                return _ref.apply(this, arguments);
            };
        }();
        var onFailed = function(val) {
            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                taskHandler: 'contact_info_screen-submit',
                taskState: 0,
                growArea: JSON.stringify({
                    msg: val.errors[0].name
                }),
                eventIntervalSpan: new Date() - enterTime.value
            }));
        };
        // relation
        var currIndex = ref(0);
        var patternPhone = ref(/^(?!25|26|36|51|52|53|54|57|85|88|94)(?!295|490|688|690|730|792|794)[2-9][1-9]\d{8}$/);
        var codeRelation1 = ref('');
        var textRelation1 = ref('');
        var name1 = ref('');
        var phone1 = ref('');
        var codeRelation2 = ref('');
        var textRelation2 = ref('');
        var name2 = ref('');
        var phone2 = ref('');
        var codeRelation3 = ref('');
        var textRelation3 = ref('');
        var name3 = ref('');
        var phone3 = ref('');
        var codeRelation = computed(function() {
            switch(currIndex){
                case 1:
                    return codeRelation1.value;
                case 2:
                    return codeRelation2.value;
                case 3:
                    return codeRelation3.value;
                default:
                    return '';
            }
        });
        var columnsRelation = ref([]);
        var showPickerRelation = ref(false);
        var showPopup = function(index) {
            currIndex.value = index;
            showPickerRelation.value = true;
        };
        var onConfirmRelation = function(value) {
            if (currIndex.value === 1) {
                codeRelation1.value = value === null || value === void 0 ? void 0 : value.mainLock;
                textRelation1.value = value === null || value === void 0 ? void 0 : value.worthValue;
            } else if (currIndex.value === 2) {
                codeRelation2.value = value === null || value === void 0 ? void 0 : value.mainLock;
                textRelation2.value = value === null || value === void 0 ? void 0 : value.worthValue;
            } else if (currIndex.value === 3) {
                codeRelation3.value = value === null || value === void 0 ? void 0 : value.mainLock;
                textRelation3.value = value === null || value === void 0 ? void 0 : value.worthValue;
            }
            showPickerRelation.value = false;
        };
        var initData = function(dictionary) {
            columnsRelation.value = objToArray(dictionary.dataMap.linkConnection);
        };
        onBeforeMount(function() {
            if (creditStore.dictionary) {
                initData(creditStore.dictionary);
            }
        });
        watch(function() {
            return creditStore.dictionary;
        }, function(newVal) {
            if (newVal) {
                initData(newVal);
            }
        }, {
            immediate: true
        });
        return {
            __sfc: true,
            agreed: agreed,
            enterTime: enterTime,
            PrivacyDataBox: PrivacyDataBox,
            isShowFirstRetainPopup: isShowFirstRetainPopup,
            isShowSecondRetainPopup: isShowSecondRetainPopup,
            showSecondRetainPopup: showSecondRetainPopup,
            goAppHome: goAppHome,
            CreditFirstRetainPopup: CreditFirstRetainPopup,
            CreditSecondRetainPopup: CreditSecondRetainPopup,
            router: router,
            creditStore: creditStore,
            userStore: userStore,
            onSubmit: onSubmit,
            onFailed: onFailed,
            currIndex: currIndex,
            patternPhone: patternPhone,
            codeRelation1: codeRelation1,
            textRelation1: textRelation1,
            name1: name1,
            phone1: phone1,
            codeRelation2: codeRelation2,
            textRelation2: textRelation2,
            name2: name2,
            phone2: phone2,
            codeRelation3: codeRelation3,
            textRelation3: textRelation3,
            name3: name3,
            phone3: phone3,
            codeRelation: codeRelation,
            columnsRelation: columnsRelation,
            showPickerRelation: showPickerRelation,
            showPopup: showPopup,
            onConfirmRelation: onConfirmRelation,
            initData: initData,
            SelectPopup: SelectPopup
        };
    }
};
